import { Button, ButtonProps, Text, useBreakpointValue, useDimensions } from "@chakra-ui/react"
import { useRef } from "react"

type Props = ButtonProps & { label: string }

// TODO (vva) After chakra ui version 2.5.1, revisit this to style the buttons for S size to have smaller padding start and no padding end
// TODO (vva) Unify the dividers on the SPDP and PDP so that we have smaller padding top and larger padding bot to have room for the anchor navigation
// TODO (vva) Create a new componenet for the share button + share modal for the CTA buttons

const ButtonWithLeftIcon = ({ label, noOfLines, variant = "secondary", ...rest }: Props) => {
  // Default height of button for the secondary variant used here
  const DEFAULT_BUTTON_HEIGHT = useBreakpointValue({ base: 44, md: 40 })
  const textRef = useRef(null)
  const textDimensions = useDimensions(textRef, true)
  const isMultiline = textDimensions?.borderBox?.height > DEFAULT_BUTTON_HEIGHT / 2 // Should be more than height of text span when only on one line

  return (
    <Button
      {...rest}
      variant={variant}
      py="1"
      paddingInlineStart={{ base: "3", md: "2.5" }}
      paddingInlineEnd={{ base: "3", md: "2.5" }}
      sx={{ "& > span": { alignSelf: `${isMultiline ? "start" : "center"}` } }}
    >
      <Text as="span" ref={textRef} noOfLines={noOfLines}>
        {label}
      </Text>
    </Button>
  )
}

export default ButtonWithLeftIcon
